import React from 'react';
import * as S from './UploadInfo.styles';

const UploadInfo = ({filesize, filename, reset}) => {
    return(
        <S.UploadedFileInfo>
            <S.ImageInfoWrap>
                <S.UploadImgMainText>{filename}</S.UploadImgMainText>
                <S.SubInfoText>{filesize.toFixed(2)} MB</S.SubInfoText>
            </S.ImageInfoWrap>
            <S.CloseIcon onClick={reset}>x</S.CloseIcon>
        </S.UploadedFileInfo>
    )
}

export default UploadInfo;